import { React, useState, useEffect } from 'react';
import ContactInfo from './ContactInfo'
import PersonalInformation from './PersonalInformation'
import CreditReport from './CreditReport';
import CreditCard from './CreditCard';
import IDIQ from './IDIQ';
import ThankYou from './thankyou'
import './styles/style.scss';
import Calendar from './Calendar';

const postParams = data => {
    return {
        method: 'POST',
        headers: { 'Content-Type' : 'application/json' },
        body: JSON.stringify(data)
    };
}

let defaultFormState = localStorage.getItem('formState')
if(!defaultFormState) {
    defaultFormState = {
        step: 0,
        token: null
    };
} else {
    defaultFormState = JSON.parse(defaultFormState)
}

const RootComponent = ({ setError, siteInfo }) => {
    const [formState, _setFormState] = useState(defaultFormState);
    const [pageState, setPageState] = useState({});

    // Please call this instead of _setFormState, for persistence
    const setFormState = (state) => {
        // Save to local storage for browser resumption, removing PII
        const safeState = {...state}
        delete safeState['ss']
        delete safeState['dob']
        delete safeState['idiq_email']
        delete safeState['idiq_pass']
        localStorage.setItem('formState', JSON.stringify(safeState))

        // Save to server for partial lead generation
        fetch("/sapi/crm_save", postParams(state))
            .then(res => res.json())
            .then(json => console.log('backend response', json))
            .catch(err => {
                setError("Error continuing your form. Please try again.")
                console.log("Backend error: ", err)
            })

        // Set the internal app state
        _setFormState(state)
        setPageState(state)

        // Submit it if we're done
        if(state.step == formPages.length - 1) {
            console.log('submitting', state)
            submitForm(state)
        }
    }

    // Final function to call: Submit the form to the CRM backend and clean up
    const submitForm = (formState) => 
        fetch("/sapi/crm_complete", postParams(formState))
            .then(res => res.json())
            .then(json => localStorage.removeItem('formState'))
            .catch(err => {
                setError("Error submitting your form. Please try again.")
                console.log("Backend error: ", err)
            })

    // Load initial state from browser storage
    useEffect(() => {
        const initialState = localStorage.getItem('formState')
        if (!!initialState) {
            const state = JSON.parse(initialState)
            _setFormState(state)
            setPageState(state)
        }
    }, [])

    // Ensure we have a server token
    useEffect(() => {
        if(!formState.token) {
            fetch("/sapi/crm_gen_token")
                .then(res => res.json())
                .then(json => setFormState({...formState, token: json.res}))
                .catch(err => {
                    setError("Error connecting to the server, please try again.")
                    console.log("Backend error: ", err)
                })
        }
    }, [formState])

    // Every form takes these props
    const formProps = { formState, setFormState, siteInfo, pageState, setPageState }

    // The index is the step
    let formPages = [
        <ContactInfo {...formProps} />,
        <PersonalInformation {...formProps} />,
        // <CreditCard {...formProps} />,
        // <CreditReport {...formProps} />,
        <IDIQ {...formProps} />,
        <Calendar {...formProps} />,
        <ThankYou {...formProps} />
    ];
    const formPage = formPages[formState.step]

    // Next button event
    const nextPage = () => {
        const step = formState.step + 1
        setFormState({...formState, ...pageState, step})
    }

    // Back button event
    const prevPage = () => {
        if (formState.step > 0) {
            const step = formState.step - 1
            setFormState({ ...formState, ...pageState, step })
        }
    }

    return (
        <div className="personal-info">
            {formPage}
            {formState.step < formPages.length - 1 && <div className="nav-buttons">
                {formState.step > 0 && <button disabled={formState.step===0} onClick={e => prevPage()} className="btn back" style={{backgroundImage: siteInfo.buttonColor}}>
                    &laquo; Back
                </button>}
                <button onClick={e => nextPage(e)} className="btn next" style={{backgroundImage: siteInfo.buttonColor}}>
                    Continue &raquo;
                </button>
            </div>}
        </div>
    );
}

export default RootComponent